import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { adminFetch } from '../utils/adminFetch';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAdmin = useCallback(async () => {
    try {
      const response = await adminFetch(`${API}/admin/me`);
      if (response.ok) {
        const data = await response.clone().json();
        setAdmin(data);
      } else {
        const token = sessionStorage.getItem('admin_token');
        const email = sessionStorage.getItem('admin_email');
        if (token && email) {
          setAdmin({ email, authenticated: true });
        } else {
          setAdmin(null);
        }
      }
    } catch (error) {
      const token = sessionStorage.getItem('admin_token');
      const email = sessionStorage.getItem('admin_email');
      if (token && email) {
        setAdmin({ email, authenticated: true });
      } else {
        setAdmin(null);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAdmin();
  }, [checkAdmin]);

  const login = async (email, password) => {
    const response = await adminFetch(`${API}/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });
    
    if (!response.ok) {
      const error = await response.clone().json();
      throw new Error(error.detail || 'Error de autenticación');
    }
    
    const data = await response.clone().json();
    if (data.token) {
      sessionStorage.setItem('admin_token', data.token);
    }
    setAdmin({ email: data.email, authenticated: true });
    return data;
  };

  const logout = async () => {
    try {
      await adminFetch(`${API}/admin/logout`, {
        method: 'POST'
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    sessionStorage.removeItem('admin_token');
    sessionStorage.removeItem('admin_email');
    setAdmin(null);
  };

  return (
    <AdminContext.Provider value={{ admin, loading, login, logout, checkAdmin }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};
